import React from "react";
import { Button, ArrowLeftIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const DefaultButtonWithStartIcon = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Contained button with start icon"}
        value={"<Button startIcon={<ArrowLeftIcon />}>Back</Button>"}
      >
        <Button startIcon={<ArrowLeftIcon />}>Back</Button>
      </PreviewAndEditor>
    </>
  );
};

export default DefaultButtonWithStartIcon;
